<!--文本详情-->
<template>
  <div class="basic-text">
    <header-index/>
    <div class="basic-content">
      <div class="basic-details-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/ServiceCentre/serviceCloud?pName='+cityList.abridge+'企服务云' }">
            {{ cityList.abridge }}企服务云
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/enterpriseSearch/index' }">企业查询</el-breadcrumb-item>
          <el-breadcrumb-item><a @click="back">企业详情</a></el-breadcrumb-item>
          <el-breadcrumb-item>文本详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-row class="basic-details">
        <el-col :span="24" style="text-align: center;font-size: 24px;padding-bottom: 30px">{{ title }}</el-col>
        <el-col :span="24"
                style="color: #999999;font-size: 14px;padding-left: 40px;padding-bottom: 20px;text-align: center">
          <span>来源：{{ source }}</span><span style="padding-left: 60px;">发布时间：{{ releaseDate }}</span></el-col>
        <el-col :span="24" style="padding: 0px 40px 30px;" v-html="detail" :style="'min-height:'+height_min+'px;'"/>
      </el-row>
    </div>
    <home_footer/>
    <Hang/>
  </div>
</template>
<script>
import {corporateNewsDetails} from '@/api/enterpriseDetailsApi'
import HeaderIndex from "@/components/header/headerIndex";
import cityJson from "@/static/cityJson.json";
import Home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hangs";

export default {
  name: "textDetails",
  components: {Hang, Home_footer, HeaderIndex},
  data() {
    return {
      /*公司id*/
      cid: 0,
      cityList:{},
      id: '', title: '', source: '', releaseDate: '', detail: '',
      height_min: document.documentElement.clientHeight - 300,
    }
  },
  methods: {
    getCorporateNewsDetails() {
      corporateNewsDetails({id: this.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.title = res.content.title;
          this.source = res.content.origin;
          this.detail = res.content.text;
          this.releaseDate = res.content.time;
        }
      })
    },
    back() {
      window.history.back();
    }
  },
  mounted() {
    this.id = this.$route.query.id;
    this.cid = this.$route.query.cid;
    if (sessionStorage.getItem('setPositioning')) {
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    } else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name)
          this.cityList = li;
      }
    }
    this.getCorporateNewsDetails();
  }
}
</script>
<style scoped>
.basic-text >>> .basic-content .basic-details-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-family: 'SourceHanSansCN';
  color: #666666;
}
.basic-text >>> .basic-content .basic-details-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.basic-text >>> .basic-content .basic-details-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.basic-text >>> .basic-content .basic-details-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.basic-text >>> .basic-content .basic-details-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}
.basic-text >>> .basic-content .basic-details-breadcrumb .el-breadcrumb {
  font-size: 14px;
  line-height: normal;
}
.basic-text >>> .basic-content .basic-details-breadcrumb .el-breadcrumb__inner a,
.basic-text >>> .basic-content .basic-details-breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}
.basic-text >>> .basic-details image {
  max-width: inherit;
  width: inherit;
}

.basic-text >>> .basic-details img {
  max-width: inherit;
  width: inherit;
}

.basic-text >>> .basic-details p {
  line-height: 25px;
}
</style>
<style scoped lang="scss">
.basic-text {
  background: #ECEEF5;
  /*企业基本信息css样式*/
  .basic-content {
    padding: 10px 18%;
    background: #ECEEF5;
    min-width: 76rem;
    .basic-details {
      background: white;
      padding: 30px;
      overflow: auto;
      margin-top: 10px;
    }
  }
}
</style>